import { OrganisationFrameworksProvider } from "@hooks/context/useOrganisationFrameworksContext";
import ScrollToTop from "@ui/atoms/ScrollToTop/ScrollToTop";
import NotificationDrawer from "@layout/NotificationDrawer/NotificationDrawer";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { MainPageLayout } from "@layout/MainPageLayout";
import { MainSectionLayout } from "@layout/MainSectionLayout";
import { resolveSelectedItem } from "../selectedItem";
import OrganisationLayoutSidebarWrapper from "./OrganisationLayoutSidebarWrapper";

export interface Props {
  children: React.ReactNode;
}

const OrganisationLayout = ({ children }: Props) => {
  const location = useLocation();
  const [selectedItem, setSelectedItem] = useState<string>("");

  useEffect(() => {
    setSelectedItem(resolveSelectedItem(location.pathname));
  }, [location.pathname]);

  return (
    // Wraps the sidebar AND the page: both read the organisation's frameworks,
    // and one fetch serves them. The sidebar's own state lives above both
    // layouts, in RootShell.
    <OrganisationFrameworksProvider>
      <ScrollToTop />
      <MainPageLayout>
        <OrganisationLayoutSidebarWrapper
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
        />

        <MainSectionLayout>{children}</MainSectionLayout>
      </MainPageLayout>
      <NotificationDrawer context="organisation" />
    </OrganisationFrameworksProvider>
  );
};

export default OrganisationLayout;
